import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';
import { HELP_API, HelpRegistry } from '@chess/api-help';
import { HelpHost } from '@chess/api-help/react';

// The help overlay, hosted once for the whole app. Provides the `help` API
// (a registry of topics: plugins `register(id, { title, body })` in their
// setup) and mounts `HelpHost` in the frame's `shell.overlays` slot, which
// shows a topic over the page when a `HelpButton` asks for it and gives the
// focus back to the button when it closes. A card only renders
// `<HelpButton topic="…" />` (`@chess/api-help/react`). See
// docs/architecture/core/plugin-shared-help.md.
export function setup(app: PiletApi) {
  const help = new HelpRegistry();
  app.registerApi(HELP_API, help);
  app.registerExtension('shell.overlays', () => <HelpHost help={help} />);
}
